<template>
  <div class="row grafico-consumo">
    <div class="col-xs-12">
      <h3>{{ title }}</h3>
    </div>
    <div v-if="unidades.length" class="col-xs-12">
      <h4>Unidades</h4>
    </div>
    <div v-if="unidades.length" class="col-xs-12 col-md-10 col-lg-8 form-group">
      <v-select
        :ref="`unidades-${title}`"
        class="style-chooser"
        v-model="unidadeFiltro"
        label="nome"
        :placeholder="'Filtrar pela unidade...'"
        :get-option-label="getLabel"
        :options="unidades"
        :selectOnTab="true"
      >
        <template slot="no-options">
          Unidade não encontrada...
        </template>
      </v-select>
    </div>
    <div class="col-xs-12">
      <bar-chart
        :ref="reference"
        :gradiente="false"
        :chart-data="chartData"
        :options="getChartOptions({ money })"
      ></bar-chart>
    </div>
  </div>
</template>

<script>
import { mesesAbr } from '@/utils'
import colors from '@/utils/colors'
import { BarChart } from '../common/BarChart'

export default {
  name: 'GraficoConsumo',
  components: { BarChart },
  props: {
    title: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    keyValue: {
      type: String,
      required: true
    },
    money: {
      type: Boolean,
      default: false
    },
    unidades: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return { unidadeFiltro: null }
  },
  methods: {
    getLabel(option) {
      return `${option.nome} - ${option.sigla}`
    },
    getChartOptions(options = { money: false }) {
      const base = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMax: 20,
                callback: function(value) {
                  return options.money
                    ? value.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    : value.toLocaleString()
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label
              var yLabel = options.money
                ? tooltip.yLabel.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                : tooltip.yLabel.toLocaleString()
              return xLabel + ': ' + yLabel
            }
          }
        }
      }

      return { ...base }
    },
    getValoresGrafico({ lista, keyValue }) {
      const dados = new Array(12).fill(0)
      const objetosDataset = {}
      let datasets = []

      lista.forEach(element => {
        const ano = element['ano_ref']
        const mes = parseInt(element['mes_ref']) - 1
        const valor = parseFloat(element[keyValue])

        if (objetosDataset.hasOwnProperty(ano)) {
          _.first(objetosDataset[ano]).data[mes] += valor
          return
        }

        const novoDado = [...dados]
        novoDado[mes] = valor

        objetosDataset[ano] = [
          { label: ano, data: [...novoDado], backgroundColor: colors.coresHexa }
        ]
      })

      const anos = Object.keys(objetosDataset)

      anos.forEach(element => {
        datasets = [...datasets, ...objetosDataset[element]]
      })

      return { labels: mesesAbr, datasets }
    }
  },
  computed: {
    chartData() {
      let values = this.values

      if (this.unidadeFiltro) {
        const filter = item => {
          return item.codigo_secretaria === parseInt(this.unidadeFiltro.id)
        }

        values = values.filter(filter)
      }

      return this.getValoresGrafico({
        lista: values,
        keyValue: this.keyValue
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Consumo/GraficoConsumo.vue